import { gql } from '@apollo/client';

const LABEL_DETAILS_FRAGMENT = gql`
  fragment LabelDetailsFragment on Label {
    name
    displayName
  }
`;

export const LabelFragments = [
  LABEL_DETAILS_FRAGMENT
];
